import React from "react"
import {getCustomerId, getTenantId} from "../../../utils/Routes"
import {useLocation} from "react-router-dom"
const CustomerDetails = () => {
	useLocation()

	const iframeSrc = `${
		process.env.REACT_APP_CARE_CUSTOMER_UI
	}/?shopperId=${getCustomerId()}&hideheader=true&tenantId=${getTenantId()}`
	return (
		<div>
			<iframe
				key={iframeSrc}
				src={iframeSrc}
				title="Designer"
				width={"100%"}
				height="2000px"
				allow="clipboard-write; clipboard-read"
			/>
		</div>
	)
}

export default CustomerDetails
